// Lightweight GA4 ecommerce helpers for GTM dataLayer pushes

export const getCurrency = (im_custom = {}) => im_custom.currency || 'USD';

export const cartToItems = (cart = {}, im_custom = {}) => {
    const items = [];
    const plan = cart.activePlan;
    const attendees = cart.attendees || [];
    const users = cart.users || [];
    const eventPrice = im_custom.event_price || {};

    if (plan && plan.plan_id) {
        items.push({
            item_id: String(plan.plan_id),
            item_name: plan.plan_label || 'Membership',
            item_category: 'membership',
            price: Number(plan.price) || 0,
            quantity: 1,
        });

        const additionalUsers = users.filter((u) => u.isDefault === "0");
        if (additionalUsers.length) {
            items.push({
                item_id: `${plan.plan_id}_user`,
                item_name: `${plan.plan_label || 'Membership'} - Additional user`,
                item_category: 'membership_user',
                price: Number(plan.extra_atlas_user_price) || 0,
                quantity: additionalUsers.length,
            });
        }

        // Only charge for extra attendees when the plan includes training tickets.
        // When training_tickets == 0 the "event" item below already represents
        // every attendee (quantity: attendees.length), so pushing extras here too
        // would double-count them in the GA4 ecommerce total.
        const extraAttendees = attendees.filter((a) => a.isDefault === "0");
        if (extraAttendees.length && plan.training_tickets > 0) {
            items.push({
                item_id: `${plan.plan_id}_training`,
                item_name: cart.activeEvent?.title || 'Training ticket',
                item_category: 'training_ticket',
                price: Number(eventPrice.extra_training_tickets_price) || 0,
                quantity: extraAttendees.length,
            });
        }

        if (plan.training_tickets == 0 && attendees.length > 0) {
            items.push({
                item_id: cart.activeEvent?.event_id ? String(cart.activeEvent.event_id) : 'event',
                item_name: cart.activeEvent?.title || 'Training Event',
                item_category: 'event',
                // First ticket gets the bulk discount once 2+ tickets are purchased
                price: (attendees.length >= 2 ? Number(eventPrice.extra_training_tickets_price) : Number(eventPrice.price)) || 0,
                quantity: attendees.length,
            });
        }
    } else if (attendees.length > 0) {
        items.push({
            item_id: cart.activeEvent?.event_id ? String(cart.activeEvent.event_id) : 'event',
            item_name: cart.activeEvent?.title || 'Training Event',
            item_category: 'event',
            // First ticket gets the bulk discount once 2+ tickets are purchased
            price: (attendees.length >= 2 ? Number(eventPrice.extra_training_tickets_price) : Number(eventPrice.price)) || 0,
            quantity: attendees.length,
        });
    }

    return items.filter((i) => i.quantity && i.quantity > 0);
};

export const pushEcommEvent = (eventName, ecommerce = {}) => {
    if (!eventName) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ecommerce,
    });
};

export const pushEcommFromCart = (eventName, cart, im_custom, extras = {}) => {
    const items = cartToItems(cart, im_custom);
    pushEcommEvent(eventName, {
        currency: getCurrency(im_custom),
        items,
        ...extras,
    });
};

